import { Component, EventEmitter, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { takeUntil } from "rxjs";
import { InviteMemberDialogComponent } from "../../../invite-member-dialog/invite-member-dialog.component";

@Component({
  selector: "app-invite-member-button",
  templateUrl: "./invite-member-button.component.html",
  styleUrls: ["./invite-member-button.component.scss"],
})
export class InviteMemberButtonComponent {
  /**
   * Emitted each time the invite dialog successfully sends an invitation, so callers can reload
   * their organization's data while the dialog is still open.
   */
  @Output() memberInvited = new EventEmitter<void>();

  constructor(private readonly dialog: MatDialog) {}

  /**
   * Opens the dialog to invite a new member to the organization.
   */
  openInviteDialog(): void {
    const dialogRef = this.dialog.open(InviteMemberDialogComponent, {
      width: "450px",
    });

    dialogRef.componentInstance.memberInvited.pipe(takeUntil(dialogRef.afterClosed())).subscribe(() => {
      this.memberInvited.emit();
    });
  }
}
